import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { logos, rs } from "../../assets";
import MenuList from "../MenuList";
import "./index.css";
import { Link } from "react-router-dom";

const Footer = ({ windowDimension }) => {
  const offset = useRef(null);
  const footer = useRef(null);
  const [offsetMargin, setOffsetMargin] = useState(null);

  useEffect(() => {
    return setOffsetMargin(footer.current.clientHeight);
  }, [windowDimension]);

  const RSlist = [
    {
      href: "https://www.instagram.com/",
      src: rs.ig.src,
      alt: rs.ig.alt,
    },
    {
      href: "https://www.facebook.com/",
      src: rs.fb.src,
      alt: rs.fb.alt,
    },
    {
      href: "https://www.linkedin.com/company/replaceit/",
      src: rs.in.src,
      alt: rs.in.alt,
    },
  ];

  return (
    <>
      <div
        className="offset"
        style={{
          height: offsetMargin + "px",
        }}
        ref={offset}
      ></div>
      <footer
        className="footer flex flexCol vertCenter justifyEnd"
        ref={footer}
      >
        <div className="container-lg flex flexCol alignCenter">
          <img
            className="footerLogo"
            src={logos.isoFooter.src}
            alt={logos.isoFooter.alt}
          />
          <nav className="menuFooter flex flexRow gap">
            {MenuList.map((menu, index) => (
              <Link className="menuLinkFooter" to={menu.href} key={index}>
                {menu.text}
              </Link>
            ))}
          </nav>
          <div className="rs flex flexRow justifySpace">
            {RSlist.map((social, index) => (
              <a
                href={social.href}
                target="_blank"
                rel="noreferrer"
                key={index}
              >
                <img src={social.src} alt={social.alt} />
              </a>
            ))}
          </div>
          <div className="footerCopy flex flexRow justifySpace">
            <p>© 2022 Replace. Todos los derechos reservados.</p>
            <p>
              <a href="#priv">Política de Privacidad</a> |{" "}
              <a href="#cookies">Política de Cookies</a> |{" "}
              <a href="#term">Términos y Condiciones</a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
